import { render, staticRenderFns } from "./Emergency.vue?vue&type=template&id=7bf5c37d"
import script from "./Emergency.vue?vue&type=script&lang=js"
export * from "./Emergency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports